import * as Popover from '@radix-ui/react-popover';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { useT } from '../i18n';
import { usePhone } from '../lib/usePhone';

/**
 * Under the message field: people are talking to an AI assistant, and its answers can be wrong
 * (EU AI Act, art. 50). "More info" explains it and links to the company's AI policy when Admin
 * has one.
 */
export function AiNotice({ id }: { id: string }) {
  const t = useT();
  const phone = usePhone();
  return (
    <p className="nv-ai-notice">
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6M12 7.5h.01" />
      </svg>
      <span id={id}>{phone ? t('aiNoticeShort') : t('aiNotice')}</span>
      <Popover.Root>
        <Popover.Trigger className="nv-ai-notice-more">{t('aiNoticeMore')}</Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            side="top"
            align="center"
            sideOffset={8}
            collisionPadding={12}
            className="popover-surface nv-ai-notice-card z-50 w-[min(360px,calc(100vw-24px))] rounded-2xl p-4"
          >
            <AiNoticeCard />
            <Popover.Arrow className="fill-bg-panel" />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </p>
  );
}

/** The card behind "More info"; only mounted when it opens. */
function AiNoticeCard() {
  const t = useT();
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me(), retry: false });
  const policyUrl = me.data?.aiPolicyUrl ?? null;
  return (
    <>
      <h2>{t('aiNoticeTitle')}</h2>
      <p>{t('aiNoticeModels')}</p>
      <p>{t('aiNoticeMedia')}</p>
      {policyUrl && (
        <p>
          <a href={policyUrl} target="_blank" rel="noreferrer noopener">
            {t('aiNoticePolicy')}
          </a>
        </p>
      )}
    </>
  );
}
